import React from "react";

const EmailIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        fill="#3E4456"
        fillRule="evenodd"
        d="M13 5h2v5c0 2.47.189 3 1 3 1.304 0 2-.617 2-3 0-5.29-2.653-8-8-8a8 8 0 104.692 14.48l1.173 1.62A10 10 0 119.999 0c6.462 0 10 3.616 10 10 0 3.545-1.64 5-4 5-1.343 0-2.113-.433-2.535-1.395A5 5 0 1113 6V5zm0 5a3 3 0 11-6 0 3 3 0 016 0z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};

export default EmailIcon;
